module.exports = __webpack_public_path__ + "static/media/icon-alert.b09e6a92.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-alert.svg
// module id = 1268
// module chunks = 19